import React, { useState } from "react";
import { Toaster } from "components";

import ic_deduct_credit from 'assets/images/ic_deduct_credit.svg';
import ic_delete from 'assets/images/ic_delete_invoices.svg';

import { func_validation } from 'functions';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { FormInput_text } from "components/form/formInput/FormInput_text";


export function usePendingKnockOff(props) {
    const {
        selectedDebitNotes,
        totalRequests,
        knockOffCredit_requesting
    } = props;

    // States
    const [isModalVisible, setIsModalVisible] = useState();
    const [debitNoteId, setDebitNoteId] = useState();

    function knockOffCredit() {
        if (func_validation.isFunction(props.setAlertMsg)) props.setAlertMsg([]);

        if (func_validation.isArrayNotEmpty(selectedDebitNotes)) {
            selectedDebitNotes.map((debitNoteDetails, idx) => {
                let id = func_validation.getObjectPropertyValue(debitNoteDetails, "Id");

                if (func_validation.isNumberValid(id) &&
                    func_validation.isFunction(props.knockOffCredit)) {

                    props.knockOffCredit(id);
                }
            });
        }
        else if (func_validation.isNumberOrStringValid(debitNoteId) &&
            func_validation.isFunction(props.knockOffCredit)) {

            props.knockOffCredit(debitNoteId);
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 debit note.",
            });
        }
    }

    let tableActions = [
        {
            icon: ic_delete,
            label: "Delete",
            isDisabled: func_validation.isUserAccessDenied(props, "Internal_AdvancePay_Delete"),
            onClick: () => {
                if (func_validation.isArrayNotEmpty(selectedDebitNotes)) {
                    if (func_validation.isFunction(props.setIsDeleteModalVisible))
                        props.setIsDeleteModalVisible(true);

                    if (func_validation.isFunction(props.setSelectedDebitNotes))
                        props.setSelectedDebitNotes(selectedDebitNotes);
                }
                else {
                    Toaster({
                        type: "info",
                        msg: "Please select at least 1 debit note.",
                    });
                }
            },
        }
    ];

    let filters = {
        postStatus: "unknocked",
    };
    let tabDetails = {
        id: "pendingKnockOff",
        text: "Pending Knock Off",
        filters
    };

    let mainTableActionDetails = {
        onClick: () => { setIsModalVisible(true) },
        isDisabled: func_validation.isUserAccessDenied(props, "Internal_AdvancePay_KnockOff"),
        icon: ic_deduct_credit,
        alt: "Debit Icon"
    };

    let pendingKnockOffModal = (
        <ConfirmationModal
            description={"Knock off credit(s)"}
            className={"debit-note__pending-knock-off"}
            input={(!func_validation.isArrayNotEmpty(selectedDebitNotes)) ? (
                <FormInput_text
                    inputLabel={"Debit Note ID"}

                    className={"pending-knock-off__debit-note-id"}
                    inputValue_default={debitNoteId}

                    isInputBlurHandlingRequired
                    handleInputBlurExtend={(value) => { setDebitNoteId(value); }}

                    inputMaxLength={64}

                    isInputValueTrim_onChange
                    isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                    isInputOptional
                />
            ) : ""}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={knockOffCredit}
            isActionLoading={knockOffCredit_requesting}
            isConfirmSuccessful={totalRequests == 0}
        />
    );

    return {
        tableActions,
        mainTableActionDetails,
        tabDetails,
        filters,
        pendingKnockOffModal
    }
}